const updateProgressBar = (event) => {
  const progressBar = document.querySelector('[data-progress-bar]');
  if (event?.detail?.progress !== null) {
    progressBar.style.width = `${event.detail.progress}%`;
  }
};

document.addEventListener('progressbar:update', updateProgressBar);
